<div class="extended-rc-bar">
    <div class="rc-bar-item rc-recording-status">{{recordingPaused ? ('videoRecording_Paused' | xsI18n ) : ('videoRecording_Recording' | xsI18n )}}</div>
    <div class="rc-bar-divider"></div>
    <div class="rc-bar-item rc-bar-action">
        <div class="hd-icon rc-bar-icon hd-icon-stopVideo"
            [soti-tooltip]="'videoRecording_Stop_Recording' | xsI18n "
            placement="top"
            [delay]="500"
            [class.red-icon] = "!recordingPaused"
            (click)="stopRecording()"
        ></div></div>
    <div class="rc-bar-item rc-bar-action">
        <div
            class="hd-icon rc-bar-icon"
            [soti-tooltip]="recordingPaused ? ('videoRecording_Resume_Recording' | xsI18n ) : ('videoRecording_Pause_Recording' | xsI18n )"
            placement="top"
            [delay]="500"
            [class.hd-icon-pauseVideo] = "!recordingPaused"
            [class.hd-icon-recordingVideo] = "recordingPaused"
            (click)="pauseResumeRecording()"
        ></div>
    </div>
</div>
